import {Link} from 'react-router';

import MailIcon from '@/assets/icons/mail.svg?react';
import ContactUsForm from '@/features/contactUsForm';
import AppLogo from '@/shared/components/AppLogo';
import {BUMPY_GROUP} from '@/shared/consts/legal';
import {SUPPORT_EMAIL} from '@/shared/consts/socialLinks';
import {APP_ROUTES} from '@/utils_legacy/routes';
import Footer from '@/widgets/footer';

export default function ContactUs() {
  return (
    <div>
      <div className="flex h-[80px] items-center justify-center bg-white sm:h-[100px]">
        <Link to="/">
          <AppLogo className="h-auto w-[75px] text-primary sm:w-[120px]" />
        </Link>
      </div>
      <div className="mx-auto w-full max-w-[1024px]">
        <div className="px-4 pt-5 pb-8 text-black sm:pb-12">
          <h1 className="mb-4 font-bold text-2xl sm:text-3xl">Contact Us</h1>
          <p>Have a question, idea, or need help?</p>
          <p>We’d love to hear from you — and we’ll get back to you soon.</p>
        </div>
        <ContactUsForm />
        <div className="flex flex-col gap-4 px-4 py-12">
          <p className="font-semibold text-lg text-link sm:text-xl">
            Registered Address:
          </p>
          <p className="whitespace-pre-line text-base sm:text-lg">
            {BUMPY_GROUP.address.replaceAll(',', '\n')}
          </p>
        </div>
        <div className="flex flex-col gap-4 px-4 text-base sm:text-lg">
          <div className="flex flex-wrap items-center gap-1">
            <p>View our</p>
            <a
              href={APP_ROUTES.TermsOfServiceGroup}
              className="cursor-pointer font-normal text-system-blue hover:accent-system-blue"
              target="_blank"
              rel="noopener noreferrer"
            >
              Terms of Use
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-1">
            <p>Learn how we protect your data in our</p>
            <a
              href={APP_ROUTES.PrivacyPolicyGroup}
              className="cursor-pointer font-normal text-system-blue hover:accent-system-blue"
              target="_blank"
              rel="noopener noreferrer"
            >
              Privacy Policy
            </a>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            <p>Need help? Email us at</p>
            <a
              href={`mailto:${SUPPORT_EMAIL}`}
              className="flex cursor-pointer items-center font-normal text-system-blue hover:accent-system-blue"
            >
              <MailIcon className="mr-2 fill-dark-gray" />
              {SUPPORT_EMAIL}
            </a>
          </div>
        </div>
      </div>
      <Footer legal={BUMPY_GROUP} />
    </div>
  );
}
